import { ID } from 'shared/types/id';

const pushNotificationTokenDateKey = 'push-notification-token-date';

export const getPushNotificationTokenDate = (uid?: ID): Date | null => {
  const dateStatesPerUidString = window.localStorage.getItem(
    pushNotificationTokenDateKey,
  );
  let statePerUid: Record<ID, string>;

  try {
    statePerUid = JSON.parse(dateStatesPerUidString ?? '') ?? {};
  } catch (e) {
    statePerUid = {};
  }

  const dateString = statePerUid[uid!];
  return dateString ? new Date(dateString) : null;
};

export const setPushNotificationTokenDate = (uid: ID, date: Date) => {
  const dateStatesPerUidString = window.localStorage.getItem(
    pushNotificationTokenDateKey,
  );
  let statePerUid: Record<ID, string>;

  try {
    statePerUid = JSON.parse(dateStatesPerUidString ?? '') ?? {};
  } catch (e) {
    statePerUid = {};
  }

  statePerUid[uid] = date.toISOString();

  window.localStorage.setItem(
    pushNotificationTokenDateKey,
    JSON.stringify(statePerUid),
  );
};

export const removePushNotificationTokenDate = (uid: ID) => {
  const dateStatesPerUidString = window.localStorage.getItem(
    pushNotificationTokenDateKey,
  );
  let statePerUid: Record<ID, string>;

  try {
    statePerUid = JSON.parse(dateStatesPerUidString ?? '') ?? {};
  } catch (e) {
    statePerUid = {};
  }

  delete statePerUid[uid];

  window.localStorage.setItem(
    pushNotificationTokenDateKey,
    JSON.stringify(statePerUid),
  );
};
